import {IService, SystemComponentType} from '@gongxigames/framework/core/types';
import {IInputGestures, InputGesturesEventsMap} from '@gongxigames/framework/core/services/inputGestures/types';
import {EventManager} from '@gongxigames/framework/core/fragments/EventManager';
import {CoreDI} from '@gongxigames/framework/core/configs/CoreDI';
import {injectable} from '@gongxigames/framework/core/installer';

@injectable()
export class InputGestures implements IInputGestures, IService {
    public static NAME: symbol = CoreDI.InputGestures;

    protected movingDistance = 100;
    protected startX = 0;
    protected events: EventManager = new EventManager();
    protected domElement: HTMLElement | null;
    protected onMoveStartListener: () => void;
    protected onMoveEndListener: () => void;

    constructor() {
        this.domElement = document.querySelector<HTMLElement>('body');

        this.onMoveStartListener = this.onMoveStart.bind(this) as any;
        this.onMoveEndListener = this.onMoveEnd.bind(this) as any;
    }

    public type: SystemComponentType = 'service';

    public destroy(): void {
        this.removeEventsListener();
        this.events.clear();
    }

    protected addEventsListener(): void {
        if (this.domElement) {
            this.domElement.addEventListener('pointerdown', this.onMoveStartListener);
            this.domElement.addEventListener('pointerup', this.onMoveEndListener);
        }
    }

    protected removeEventsListener(): void {
        if (this.domElement) {
            this.domElement.removeEventListener('pointerdown', this.onMoveStartListener);
            this.domElement.removeEventListener('pointerup', this.onMoveEndListener);
        }
    }

    protected onMoveStart(e: any): void {
        this.startX = e.clientX;
    }

    protected onMoveEnd(e: any): void {
        const endX = e.clientX;

        if (endX - this.startX > this.movingDistance) {
            this.events.emit('swipeToRight');
        } else if (this.startX - endX > this.movingDistance) {
            this.events.emit('swipeToLeft');
        }

        this.startX = 0;
    }

    public hasListener<K extends keyof InputGesturesEventsMap>(id: K, owner: Object): boolean {
        return this.events.hasListener(id, owner);
    }

    public off<K extends keyof InputGesturesEventsMap>(id: K, owner: Object): void {
        this.events.off(id, owner);

        if (this.events.getNumberEvents() === 0) {
            this.removeEventsListener();
        }
    }

    public on<K extends keyof InputGesturesEventsMap>(id: K, callback: (data?: InputGesturesEventsMap[K]) => void, owner: Object): void {
        this.events.on(id, callback as any, owner);

        if (this.events.getNumberEvents() === 1) {
            this.addEventsListener();
        }
    }
}
